import { urlsConstants } from '../constants/url.constant';
import { defaultService } from './defaultService';

export const reprocessamentoService = {
  findByFiltro,
  findAll,
  reprocessarPendentesWms,
  reprocessarPendenteWms,
  findPendenciasEstoqueInternoByFiltro,
  reprocessarPendenciasEstoqueInterno,
  reprocessarPendenciaEstoqueInterno,
};

function findAll() {
  return defaultService.doGet(
    `${urlsConstants.API_REPROCESSAMENTO}pendentesWms`,
  );
}

function findByFiltro(options, filter) {
  const payload = {
    ...filter,
    page: options.page - 1,
  };

  return defaultService.doPost(
    `${urlsConstants.API_REPROCESSAMENTO}filtro`,
    payload,
  );
}

function reprocessarPendentesWms() {
  return defaultService.doPost(
    `${urlsConstants.API_REPROCESSAMENTO}reprocessarPendentesWms`,
  );
}

function reprocessarPendenteWms(id) {
  return defaultService.doPost(
    `${urlsConstants.API_REPROCESSAMENTO}reprocessarPendenteWms/${id}`,
  );
}

function findPendenciasEstoqueInternoByFiltro(options, filter) {
  const payload = {
    ...filter,
    page: options.page - 1,
    order: options.order,
    direction: options.direction,
  };

  return defaultService.doPost(
    `${urlsConstants.API_REPROCESSAMENTO}estoqueInterno/pendencias/filtro`,
    payload,
  );
}

function reprocessarPendenciasEstoqueInterno() {
  return defaultService.doPost(
    `${urlsConstants.API_REPROCESSAMENTO}estoqueInterno/pendencias/reprocessarPendentes`,
  );
}

function reprocessarPendenciaEstoqueInterno(id) {
  return defaultService.doPost(
    `${urlsConstants.API_REPROCESSAMENTO}estoqueInterno/pendencias/reprocessar/${id}`,
  );
}
